import { Component, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService, notCloseMessageOptions } from '../../../../core';
import { DatepickerComponent } from '../../../../shared';
import { MEI } from '../mei';

@Component({
    selector: 'sgt-mei-form',
    templateUrl: './mei-form.component.html',
    styleUrls: ['./mei-form.component.less']
})
export class MEIFormComponent {
    @Input() entity: MEI;
    @Input() canEdit = true;
    /** Se o form deve ser exibido em tamanho pequeno */
    @Input() isMini = false;

    @ViewChild('form') form: NgForm;
    @ViewChild('optanteMEIDataDatepicker') optanteMEIDataDatepicker: DatepickerComponent;

    constructor(private messageService: MessageService) { }

    /** Verifica se o form e suas informações está válidas */
    isValid(): boolean {
        if (!this.canEdit) {
            return true;
        }

        // Optante pelo MEI e não informada data de opção
        if (this.entity.optanteMEI && !this.entity.optanteMEIData) {
            this.messageService.warning('Selecionado empresa Optante pelo MEI (Microempreendedor Individual) e não informada a data de opção. Informe a data de opção e tente novamente', 'Atenção', notCloseMessageOptions);
            setTimeout(() => this.optanteMEIDataDatepicker?.setFocus(), 100);
            return false;
        }

        // Form válido
        if (!this.form.valid) {
            this.messageService.warning('Informe corretamente todos os campos do MEI (Microempreendedor Individual) da empresa', 'Atenção', notCloseMessageOptions);
            return false;
        }

        return true;
    }
}
